import { handleOtherResponseCode, LoginRequest, REDIRECT, SUCCESS_REPONSE_CODE, signIn, 
         UNAUTHORIZED_REPONSE_CODE, afterSigninPath, UNPROCESSABLE_ENTITY_RESPONSE_CODE,
         CustomToastrAction} from '@/imports-files/pages/admins/login';


export async function adminLoginFormSubmit(values, router, updateUser, t, userType, setDisabled, user_email)
{
  if(user_email)
  {
    values.invitation_token = router.query.invitation_token
    acceptInviteFormSubmit(values, router, setDisabled, userType)
  }
  else 
  {
    handleLoginFormSubmit(values, router, updateUser, t, userType, setDisabled)
  }
}

export async function handleLoginFormSubmit(values, router, updateUser, t, userType, setDisabled)
{
  

    // ---------------------------- Initialization ------------------------------
    setDisabled(true);
    values.user_type          =   userType
    const body                =   {user: values};
    const result              =   await new LoginRequest().isUserAuthenticated(body);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction();
    // ---------------------------- Initialization ------------------------------



    switch (status_code)
    {
        case SUCCESS_REPONSE_CODE:
                                    const response = result.data;
                                    if (response.success) 
                                    {
                                      updateUser(response);
                                      customToastrAction.setNormalToastr(response.success, 'success');
                                      // toastr.success(response.success);

                                      if(userType == "ClientUser")
                                        router.push(REDIRECT.client.otp);
                                      else if((userType == "Admin"))
                                        router.push(REDIRECT.admins.otp);
                                    }
                                    break;
        case UNAUTHORIZED_REPONSE_CODE:
                                        setDisabled(false);
                                        if(result.response.data.hasOwnProperty('remaining_attempts')){
                                          if( result.response.data.remaining_attempts > 0)
                                          {
                                              let error_mess = t('errors:attempts_left');
                                              error_mess = error_mess.replace("Number", result.response.data.remaining_attempts);
                                              customToastrAction.setNormalToastr(error_mess, 'warning');
                                          }
                                          else
                                          {
                                            customToastrAction.setNormalToastr(t('errors:acc_blocked'), 'warning');
                                            // this.customToastrAction.setNormalToastr(result.response.data.error, 'warning');
                                          }
                                        }
                                        else{
                                            customToastrAction.setNormalToastr(result.response.data.error, 'warning');
                                        }
                                        break;
                                        default:
    }
}

export async function acceptInviteFormSubmit(values, router, setDisabled, userType)
{
  const body                =   {accept_invitation: values}
  body.user_type            =   userType
  const result              =   await new LoginRequest().acceptInviteSetPassword(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction();
  
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      const response = result.data;
      if (response.success) 
      {
        await signIn('credentials', {redirect: false, body: JSON.stringify(response)});
        afterSigninPath(router, response)
      } 
      else 
      {
        console.log(response.error);
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      setDisabled(false);
      
      if(result.response.data.error?.user?.invitation_token)
      {
        customToastrAction.setNormalToastr(result.response.data.error?.user?.invitation_token, 'warning');
        // toastr.warning(result.response.data.error?.user?.invitation_token);
        router.push(REDIRECT.admins.login)
      }

      if(result.response.data.error?.user?.password) 
      {
        customToastrAction.setNormalToastr(result.response.data.error?.user?.password, 'error');
        // toastr.error(result.response.data.error?.user?.password)
      }
      break;
    default: handleOtherResponseCode(status_code, router);
  }
}

export function setInitalValues(initialValues, user_email, user_name)
{
  if(user_email)
  {
    initialValues.email = user_email;
    initialValues.name = user_name || '';
  }
  return initialValues;
}